export default class BaseTelephonyEventHandler {
  constructor(provider, device) {
    this.provider = provider;
    this.device = device;
    this.eventListeners = new Map();
  }

  initialize(device) {
    throw new Error("initialize method must be implemented by provider");
  }

  setupMessageListeners() {
    throw new Error(
      "setupMessageListeners method must be implemented by provider",
    );
  }

  setupDeviceListeners() {
    throw new Error(
      "setupDeviceListeners method must be implemented by provider",
    );
  }

  registerConnectionMessageHandlers(connection) {
    throw new Error(
      "registerConnectionMessageHandlers method must be implemented by provider",
    );
  }

  async sendMessage(connection, message) {
    throw new Error("sendMessage method must be implemented by provider");
  }

  async handleCustomMessage(message) {
    throw new Error(
      "handleCustomMessage method must be implemented by provider",
    );
  }

  on(event, callback) {
    if (!this.eventListeners.has(event)) {
      this.eventListeners.set(event, []);
    }
    this.eventListeners.get(event).push(callback);
  }

  off(event, callback) {
    if (this.eventListeners.has(event)) {
      const callbacks = this.eventListeners.get(event);
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    }
  }

  emit(event, data) {
    if (this.eventListeners.has(event)) {
      this.eventListeners.get(event).forEach((callback) => {
        try {
          callback(data);
        } catch (error) {
          console.error(`Error in event handler for ${event}:`, error);
        }
      });
    }
  }
}
